export const buttonThemes = {
  primary: {
    initial: 'bg-black text-white',
    hoverBackground: 'bg-gray-100',
    hoverText: 'text-black font-semibold',
    border: 'border border-white',
    hoverBorder: 'border-black',
  },
  secondary: {
    initial: 'bg-white text-black',
    hoverBackground: 'bg-black',
    hoverText: 'text-white font-semibold',
    border: 'border border-black',
    hoverBorder: 'border-black', // Changed from 'border-white'
  },
  tertiary: {
    initial: 'bg-designer-blue text-white',
    hoverBackground: 'bg-primary-800',
    hoverText: 'text-white font-semibold',
    border: 'border border-white',
    hoverBorder: 'border-black', // Changed from 'border-blue-500'
  },
  outline: {
    initial: 'bg-transparent text-white',
    hoverBackground: 'bg-black',
    hoverText: 'text-white font-semibold',
    border: 'border border-white',
    hoverBorder: 'border-black',
  },
  success: {
    initial: 'bg-green-500 text-white',
    hoverBackground: 'bg-white',
    hoverText: 'text-green-500 font-semibold',
    border: 'border border-white',
    hoverBorder: 'border-black', // Changed from 'border-green-500'
  },
  danger: {
    initial: 'bg-red-500 text-white',
    hoverBackground: 'bg-white',
    hoverText: 'text-red-500 font-semibold',
    border: 'border-white',
    hoverBorder: 'border-black', // Changed from 'border-red-500'
  },
};
